export default __webpack_public_path__ + "static/media/keto-chocolate-bar@3x.f1999814.png";